const FlaskIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M12 3 L12 10 L7 20 C6 22, 6 24, 8 26 C10 28, 22 28, 24 26 C26 24, 26 22, 25 20 L20 10 L20 3" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M10 3 L22 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M9 18 L23 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    </svg>
  );
};

export default FlaskIcon;

